import styled from 'styled-components';
import { Col, Row, StatusTag, Text } from 'basic-ui-lib';
import { IDevice } from 'modules/dashboard/interfaces/api';
import { ScreenStatus, StatusScreenConfigs } from 'modules/dashboard/services/constants';

interface DeviceHeaderProps {
  deviceInfo?: IDevice | null;
  screenStatus?: ScreenStatus;
  isCreateMode?: boolean;
}

// const getStatusConfig = (status?: ScreenStatus, isCreateMode?: boolean): { label: string; color: string } => {
//   if (isCreateMode) {
//     return { label: 'New', color: Colors.secondary[4] };
//   }
  
//   switch (status) {
//     case ScreenStatus.ONLINE:
//       return { label: 'Online', color: Colors.secondary[4] };
//     case ScreenStatus.OFFLINE:
//       return { label: 'Offline', color: Colors.other[3] };
//     case ScreenStatus.DRAFT:
//       return { label: 'Draft', color: Colors.yellow[5] };
//     case ScreenStatus.DEACTIVATED:
//       return { label: 'Deactivated', color: Colors.other[3] };
//     default:
//       return { label: 'Unknown', color: Colors.other[3] };
//   }
// };

const DeviceHeader = ({ deviceInfo, screenStatus }: DeviceHeaderProps) => {
  const deviceName = deviceInfo?.deviceName || 'Unknown Device';
  const deviceType = deviceInfo?.deviceType || '';
  const operatingSystem = deviceInfo?.operatingSystem || '';
  const resolution = `${operatingSystem}${deviceType ? ` • ${deviceType}` : ''}`;
  
  const statusConfig = StatusScreenConfigs[screenStatus || ScreenStatus.NEW];

  return (
    <Container>
      <Row justifyContent="space-between" alignItems="flex-start" width="100%">
        <Col gap={2} alignItems="flex-start">
          <Text content_2 semibold color="neutral.text.5">
            {deviceName}
          </Text>
          <Text caption_2 color="neutral.text.4">
            {resolution}
          </Text>
        </Col>
        <StatusTag 
          backgroundColor={statusConfig.backgroundColor} 
          label={statusConfig.label} 
          color={statusConfig.color}
        />
      </Row>
    </Container>
  );
};

export default DeviceHeader;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
